
import { MapBlock } from "@/utils/dto/art.js";
import MapView from "@/components/objects/MapView.vue";

export default {
  name: "MapBlockComponent",
  components: { MapView },
  props: {
    block: {
      type: [MapBlock, Object]
    }
  },
  computed: {
    mapData() {
      if (this.block.type === 'import') {
        return this.block.imported
      } else {
        return this.block.data.map
      }
    }
  }
}
